import ClassPage from "@/components/classPage/ClassPage";

export default [{
    path: "/csjy.html",
    name: "ClassPage",
    component: ClassPage,
    props: true,
    meta: {
        title: '就业培训班_软件测试就业培训_51Testing软件测试培训网'
    }
}, {
    path: "/cskf.html",
    name: "ClassPage2",
    component: ClassPage,
    props: true,
    meta: {
        title: '测试开发培训_51Testing软件测试培训网'
    }
}, {
    path: "/zhoumo.html",
    name: "ClassPage3",
    component: ClassPage,
    props: true,
    meta: {
        title: '周末精品班_51Testing软件测试培训网'
    }
}, {
    path: "/neixun.html",
    name: "ClassPage4",
    component: ClassPage,
    props: true,
    meta: {
        title: '团队内训_51Testing软件测试培训网'
    }
}, {
    path: "/weipei.html",
    name: "ClassPage5",
    component: ClassPage,
    props: true,
    meta: {
        title: '委培直招_51Testing软件测试培训网'
    }
}, {
    path: "/xueli.html",
    name: "ClassPage6",
    component: ClassPage,
    props: true,
    meta: {
        title: '名校专升本_51Testing软件测试培训网'
    }
}, {
    path: "/renzheng.html",
    name: "ClassPage7",
    component: ClassPage,
    props: true,
    meta: {
        title: 'ISTQB认证_51Testing软件测试培训网'
    }
}, {
    path: "/python.html",
    name: "ClassPage8",
    component: ClassPage,
    props: true,
    meta: {
        title: 'Python测试开发_51Testing软件测试培训网'
    }
},{
    path: "/mcar.html",
    name: "ClassPage9",
    component: ClassPage,
    props: true,
    meta: {
        title: '高端车载测试工程师人才培养_51Testing软件测试培训网'
    }
},]


// WEBPACK FOOTER //
// ./src/router/classpage.js